import { RefObject, useEffect, useState } from "react";
import { debounce } from "throttle-debounce";

const useHasScrollbar = (ref: RefObject<HTMLElement> | null) => {
  const [hasScrollBar, setHasScrollBar] = useState(false);

  useEffect(() => {
    function updateState() {
      const el = ref?.current;
      el && setHasScrollBar(el.scrollHeight > el.getBoundingClientRect().height);
    }

    const debouncedUpdateState = debounce(250, updateState);

    updateState();

    window.addEventListener("resize", debouncedUpdateState);
    return () => window.removeEventListener("resize", debouncedUpdateState);
  }, [ref]);

  return [hasScrollBar];
};

export default useHasScrollbar;
